import { useEffect, useState } from 'react';

/**
 * True once the reader has scrolled past the first screen.
 *
 * Latched, not a live test: the floating islands play an entrance when they
 * arrive, and scrolling back up would take them out again — which on the
 * read-aloud bar also unmounts it and cancels a reading in progress. Once
 * offered, they stay.
 *
 * The listener removes itself on the way through, so a page that is scrolled
 * for the rest of its life costs nothing after the first screen.
 */
export const useScrolledPastFirstScreen = () => {
    const [passed, setPassed] = useState(false);

    useEffect(() => {
        let frame = 0;
        const sync = () => {
            frame = 0;
            if (window.scrollY <= window.innerHeight) return;
            setPassed(true);
            window.removeEventListener('scroll', onScroll);
        };
        const onScroll = () => {
            if (frame) return;
            frame = window.requestAnimationFrame(sync);
        };

        sync();
        window.addEventListener('scroll', onScroll, { passive: true });
        return () => {
            if (frame) window.cancelAnimationFrame(frame);
            window.removeEventListener('scroll', onScroll);
        };
    }, []);

    return passed;
};
